import { render, staticRenderFns } from "./PropostaInfoColumn.vue?vue&type=template&id=1ca9f10a&scoped=true&"
import script from "./PropostaInfoColumn.vue?vue&type=script&lang=js&"
export * from "./PropostaInfoColumn.vue?vue&type=script&lang=js&"
import style0 from "./PropostaInfoColumn.vue?vue&type=style&index=0&id=1ca9f10a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca9f10a",
  null
  
)

export default component.exports